import { useLazyQuery } from "@apollo/client";
import { SavedView, SavedViewPage } from "@api/graphql/generated/generated-types";
import { useEffect, useState } from "react";
import { useAuth } from "@src/common/hooks/useAuth";
import { useErrorToast } from "@src/common/hooks/useErrorToast";
import { GET_SAVED_VIEWS } from "../graphql";
import {
  GetSavedViewsQueryResponse,
  GetSavedViewsQueryVariables,
} from "../types";

export function useSavedViewsQuery(page: SavedViewPage) {
  const showError = useErrorToast();
  const { courierId, employeeId, courieUser } = useAuth();
  const userOrEmployeeId = employeeId || courieUser?.id;

  const [savedViews, setSavedViews] = useState<SavedView[]>([]);

  const [getSavedViews, { loading, refetch }] = useLazyQuery<
    GetSavedViewsQueryResponse,
    GetSavedViewsQueryVariables
  >(GET_SAVED_VIEWS, {
    onCompleted: (data) => {
      const views = [...(data?.savedViews || [])].sort(
        (a, b) => (Number(a.createdAt) || 0) - (Number(b.createdAt) || 0)
      );
      setSavedViews(views);
    },
    onError: (error) => showError(error),
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (courierId && userOrEmployeeId) {
      getSavedViews({
        variables: {
          courierId,
          userOrEmployeeId,
          page,
        },
      });
    }
  }, [courierId, userOrEmployeeId, page]);

  const refetchSavedViews = () => {
    if (courierId && userOrEmployeeId) {
      refetch({
        courierId,
        userOrEmployeeId,
        page,
      });
    }
  };

  return {
    savedViews,
    setSavedViews,
    loading,
    refetchSavedViews,
  };
}
